<template>
  <div style="padding: 0.5rem 0.3rem;background: #F6F6F6">
    <div>
      服务协议是您与俺来也之间就俺来也提供的订餐服务等相关事宜所订立的协议。请您仔细阅读本协议，您勾选"同意并接受《打包自提用户协议》"并点击使用服务后，本服务协议对您产生约束力。您应当在使用服务平台的服务之前认真阅读、充分理解全部条款的内容，如您对条款有任何疑问的，应向平台客服咨询。
    </div>
    <div>
      <h3>1. 定义</h3>
      <p>1.1 服务平台：是搭建、提供及维护打包自提服务信息发布的平台，即俺来也平台。</p>

      <p>1.2 用户：即本协议中的“您”，是指在服务平台上下打包自提订单的俺来也外卖用户。</p>

      <p>1.3 商家：是指通过服务平台为用户提供打包自提服务的商家。用户在服务平台下打包自提订单后，服务平台将向商家推送订单，商家在在成功接受订单后，将在规定完成商品准备并等待您打包自提。</p>
    </div>
    <div>
      <h3>
        2. 服务协议的确认和接受
      </h3>
      <p>
        2.1 在您使用服务平台的服务之前认真阅读全部条款内容。如您对服务协议有任何疑问的，应联系客服咨询，如不同意，您有权拒绝使用平台提供的服务。一旦您使用服务平台的服务，即表示您已充分阅读、理解并接受本服务协议的全部内容，服务协议即对您产生约束力。届时您不应以未阅读（理解或同意）服务协议的内容为由，主张服务协议无效，或要求撤销服务协议。
      </p>
      <p>
        2.2 您在阅读并同意本服务协议并实际使用服务平台的服务时，您即受本服务协议的约束。
      </p>
      <p>
        2.3 本协议内容包括服务协议正文及所有服务平台已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与服务协议正文具有同等法律效力。您承诺接受并遵守本协议的约定，如果您不同意本协议的约定，您应立即停止使用服务平台的服务。
      </p>
      <p>
        2.4 服务平台有权根据国家法律法规的更新、产品和服务规则的调整需要不时地制订、修改本协议或各类规则，并在服务平台公示或向您的账户推送消息通知您。如您继续使用服务平台的服务的，即表示您接受经修订的协议和规则。
      </p>
    </div>
    <div>
      <h3>
        3. 服务平台提供的服务
      </h3>
      <p>
        3.1 搭建、提供及维护服务信息，为用户和商家提供信息发布和撮合交易。
      </p>

      <p>3.2 用户可以通过服务平台下打包自提订单。
      </p>
      <p>
        3.3 服务平台根据用户提交的订单信息，包括自提电话、自提时间、订单商品等，生成自提订单，并在用户支付后将订单信息推送至商家，并提醒商家根据相应的订单信息及时准确备货，以备用户前来自提。
      </p>
      <p>
        3.4 在本协议项下，服务平台仅为用户和商家提供达成双方打包自提订单的居间撮合服务。用户与商家达成的打包自提服务过程中产生的全部权利义务，包括但不限于没有取到商品、商品未及时准备、商品品质、质量和价值分歧等，由用户与商家间的违约方承担，与服务平台无关。
      </p>
      <p>
        3.5 服务平台保留在后续服务在运营过程中收取用户的平台服务费的权利，如收费，以本平台实际展示为准。服务平台保留在无须发出书面通知，仅在消息通知、短信通知、网站通知、系统推送或其他方式通知的情况下，暂时或永久地更改或停止部分或全部打包自提服务的权利。
      </p>
      <p>
        3.6 服务平台受理用户和商家的投诉，并联系对方对投诉进行调查核实。若用户对商家进行投诉，服务平台有权按照平台规则追究法律责任的权利；另外，服务平台有权禁止受投诉商家使用平台服务。若商家对用户进行投诉，服务平台有权暂时禁止受投诉用户使用平台服务。
      </p>
      <p>
        3.7 打包自提服务只能为已开通打包自提服务的城市的用户提供服务。
      </p>
    </div>
    <div>
      <h3>
        4. 用户权利义务
      </h3>
      <p>
        4.1 用户保证，通过服务平台下的自提订单时选择合理的自提商品时间及正确可联系到的自提电话，并在预定的自提时间前后不超过10分钟打包自提订单的商品。如迟到或早到，而带来的后果包括不限于等待、商品丢失、商品品质及质量下降、订单不退款等，由用户自行承担。
      </p>
      <p>
        4.2 商家接受打包自提订单后，若因用户的原因导致订单无法完成从而给商家造成损失的，用户应当予以赔偿。如因不可抗力或其他服务平台无法控制的原因使系统崩溃或无法正常使用服务平台导致网上交易无法完成或丢失有关信息、记录等，服务平台不承担责任。但是服务平台会尽可能地协助处理善后事宜，并努力使用户免受经济损失。
      </p>
      <p>
        4.3 商家就已接受的自提订单，但无法完成的，应由平台合作伙及时通知平台，或协助与用户协商解决。
      </p>
      <p>
        4.4 用户同意，在使用打包自提服务过程中出现的与商家的分歧，应由您和商家自行友好协商解决。
      </p>
      <p>
        4.5用户应当严格遵守本服务协议及服务平台发布的其他规则、须知或协议，因用户违反本服务协议或其他规则、须知或协议的行为给第三方、或给服务平台造成损失的，用户应当承担赔偿责任。
      </p>
    </div>
    <div>
      <h3>
        5. 责任范围与责任限制
      </h3>
      <p>
       5.1 用户需确认，您在实际使用服务平台的服务时，应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果，服务平台有权注销您的账户或停止向您提供服务。
      </p>
      <p>
       5.2 用户在服务平台注册成功后，将产生用户名和密码等账户信息，您可以根据服务平台的规则改变您的密码。用户应谨慎合理的保存、使用其用户名和密码并对通过您的账户和密码实施的所有行为、活动及事件负全责。用户若发现任何不当使用用户账号或存在安全漏洞等其他可能危及用户账户安全的情况，应当立即以有效方式通知服务平台，要求服务平台暂停相关服务，并向公安机关报案。您理解服务平台对您的请求采取行动需要合理时间，服务平台对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。用户不得将在本服务平台账户借（租）给他人使用，否则您应承担由此产生的全部责任。
      </p>
      <p>
        5.3 用户同意自行承担使用网络服务的风险，服务平台不作任何类型的担保，包括但不限于：不担保服务一定能满足用户的要求；不担保服务不会受中断，对服务的及时性，安全性，出错发生不担保；对在服务平台上以及第三方合作得到的任何服务或交易进程，不作担保；对平台服务所涉及的技术及信息的有效性、准确性、正确性、可靠性、稳定性、完整性和及时性不作出任何承诺和保证；不担保平台服务的适用性没有错误或疏漏。
      </p>
      <p>
        5.4 用户理解并同意服务平台作为信息发布平台，无法控制每一任务事项所涉及的商品/服务质量、安全或合法性、任务事项内容的真实性或准确性、以及任务事项所涉各方履行任务事项的能力。您应自行谨慎判断确定相关信息的真实性、合法性和有效性，并自行承担因此产生的责任与损失。您应在使用打包自提服务并自提商品时检查商品的数量是否正确及商品是否完整，在用户端操作订单完成或用户无任何操作 时后应视为认可打包自提的商品符合您的要求。
      </p>
      <p>
       5.5 用户同意并确认，服务平台拥有独自决定拒绝服务、关闭用户账户或取消任务事项的权利。
      </p>
      <p>
       5.6 用户在通过服务平台进行在线下订单等活动时，涉及用户真实姓名/名称、履行地址、联系电话等隐私信息的，服务平台将予以严格保密，除非得到用户的授权或法律法规、本条款另有规（约）定外，服务平台不会向外界披露用户隐私信息。
      </p>
      <p>
       5.7 用户同意服务平台可能会与第三方合作向用户提供相关的网络服务，在此情况下，如该第三方同意承担与服务平台同等的保护用户隐私的责任，则服务平台有权将用户的信息资料等提供给该第三方。另外，在不透露单个用户隐私资料的前提下，服务平台有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。
      </p>
      <p>
       5.8 用户对商家的评价或评分等信息都将作为服务平台的数据财产，服务平台有权予以展示、汇编及其他合理使用。用户接受本协议即表明该用户将其在服务平台发表的任何形式的信息的著作权或其他合法权利，包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利无偿独家转让给服务平台所有，同时表明用户许可服务平台有权就任何主体侵权而单独提起诉讼，并获得全部赔偿。
      </p>
      <p>
        5.9 用户同意服务平台拥有通过消息推送、平台公示、短信、电话、邮件等形式向您通知告知与本协议相关服务信息的权利，用户允许平台向其发送上述电子信息。
      </p>
    </div>
  </div>
</template>

<script>
    export default {
        name: "self-take-protocol"
    }
</script>

<style scoped>
    h3{
      font-size: 0.28rem;
      color: #333;
    }
</style>



// WEBPACK FOOTER //
// SelfTakeProtocol.vue?def3bf38